import actionTypes from '../constants/action-types';

const setBlocks = (blocks) => ({
  type: actionTypes.SET_BLOCKS,
  payload: {
    blocks,
  },
});

export default setBlocks;
